import { Form } from 'antd';
import WeightLossItem from './WeightLossItem';

import cx from './index.module.scss';

interface Props {
  weightLossProblems: AIDiagnoseSubmitParams['weightLossList'];
  handleDelete: (value: Diagnose, therapyType: AIDiagnose.TherapyType) => void;
}

const WeightLoss: React.FC<Props> = ({ weightLossProblems, handleDelete }) => {
  return (
    <div className={cx('wrapper')}>
      <div className={cx('header')}>
        <div>减肥瘦身</div>
        <div onClick={() => handleDelete('weightLossList', 'weightLoss')}>删除</div>
      </div>
      <div className={cx('title')}>围度数据</div>

      <div className={cx('content')}>
        <Form.Item name="weightLossList" noStyle>
          <Form.List name="weightLossList">
            {fields =>
              fields.map(({ key, name }) => (
                <div key={weightLossProblems?.[name]?.problem}>
                  <Form.Item noStyle name={[name, 'problem']} />
                  <Form.Item noStyle name={[name, 'goalValue']} />
                  <Form.Item noStyle name={[name, 'currentValue']}>
                    <WeightLossItem
                      name={weightLossProblems?.[name]?.problem}
                      goalValue={weightLossProblems?.[name]?.goalValue}
                    />
                  </Form.Item>
                </div>
              ))
            }
          </Form.List>
        </Form.Item>
      </div>
    </div>
  );
};

export default WeightLoss;
